import { t } from '@hefe/i18n';
import { BasketballEventDetails } from '@hefe/models';
import { EventsApi, ModalsSlice } from '@hefe/store';
import { formatDateTime } from '@hefe/utils';
import { useAppDispatch } from '../../../../store/store';
import CustomTable from '../../../core/components/table/custom-table.component';
import AddEditEventForm from '../../forms/add-edit-event/add-edit-event.form';

export default function ClubEventsPage() {
  const dispatch = useAppDispatch();

  const {
    data: events,
    isFetching,
    refetch,
  } = EventsApi.useFetchClubBasketballEventsQuery();

  const [deleteEvent, { isLoading: isDeletingEvent }] =
    EventsApi.useDeleteEventMutation();

  const openEventDetails = (event: BasketballEventDetails) => {
    dispatch(
      ModalsSlice.modalsActions.openModal({
        component: <AddEditEventForm eventId={event.id} />,
        title: event.name,
        formId: `add-edit-event-form-${event.id}`,
      })
    );
  };

  return (
    <CustomTable
      name="club-events"
      rowKey="id"
      loading={isFetching}
      dataSource={events ?? []}
      onRowClick={(event: BasketballEventDetails) => openEventDetails(event)}
      columns={[
        {
          key: 'name',
          title: t('name'),
          dataIndex: 'name',
          showFilter: true,
          default: true,
        },
        {
          key: 'date',
          title: t('date'),
          dataIndex: 'date',
          showDateFilter: true,
          default: true,
          render: (date: string) =>
            formatDateTime(date, { withHypens: true, withWeekday: 'short' }),
        },
        {
          key: 'location',
          title: t('location'),
          dataIndex: 'location',
          default: true,
        },
      ]}
      addForm={{
        title: t('events.add'),
        formId: 'add-edit-event-form-new',
        component: <AddEditEventForm />,
      }}
      deleteAction={{
        action: (keys: any[]) => (keys[0] ? deleteEvent(keys[0]) : null),
        loading: isDeletingEvent,
      }}
    />
  );
}
